export const ONE_SECOND_MILLISECONDS = 1000
export const ONE_MINUTE_MILLISECONDS = 60 * ONE_SECOND_MILLISECONDS
export const ONE_HOUR_MILLISECONDS = 60 * ONE_MINUTE_MILLISECONDS
export const ONE_DAY_MILLISECONDS = 24 * ONE_HOUR_MILLISECONDS
export const MINIMUM_YEAR = 1600
